import { render, staticRenderFns } from "./FooterSocialMediaList.vue?vue&type=template&id=0e8c5f8c&"
import script from "./FooterSocialMediaList.vue?vue&type=script&lang=coffee&"
export * from "./FooterSocialMediaList.vue?vue&type=script&lang=coffee&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports